import { Link } from 'expo-router';

export default function NotFound() {
  return (
    <div className="md:mx-auto mx-4 flex flex-col">
      <div
        className="mt-8 space-y-6 md:mx-0 max-w-2xl"
        style={{
          marginTop: '10rem',
          justifyContent: 'center',
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          paddingHorizontal: 20,
        }}
      >
        <div className="flex flex-row">
          <h1
            className={'text-3xl font-bold text-white'}
            style={{
              marginBottom: '1rem',
            }}
          >
            404 - Page Not Found
          </h1>
        </div>
        <p className="text-subtle">
          Oops! It seems like you've wandered off the beaten path.
        </p>
        <p className="text-subtle">
          Don't worry, even the best explorers get lost sometimes. Let's get you
          back on track.
        </p>
        <Link href="/" className="flex items-center">
          <p className="font-semibold underline underline-offset-2 mr-2 text-subtle">
            Back to Home
          </p>
        </Link>
      </div>
    </div>
  );
}
